<template>
  <el-form
    :model="form"
    ref="form"
  >
    <el-row :gutter="10" class="section-supplier py-2">
      <el-col :lg="3" :sm="6" :xs="12">
        <el-form-item
          :label="L10n('baxpo')"
          prop="baxpo"
          class="material-style"
        >
          <el-input
            :value="form.baxpo"
            @input="form.baxpo = valueTrimLeft($event)"
            @change="autoSave('baxpo')"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :lg="5" :sm="6" :xs="12">
        <el-form-item
          :label="L10n('supplier')"
          prop="supplierCompanyID"
          :rules="getValidationRule('required')"
          class="material-style"
        >
          <select-company
            :model.sync="form.supplierCompanyID"
            @on-change="(value, data, title) => mixChangeSupplierID(value, { label: title, required: true, ...configRFQ2 })"
            @on-created="(data) => mixCreateSupplier(data, { label: data.name, ...configRFQ2 })"
          >
          </select-company>
        </el-form-item>
      </el-col>
      <el-col :lg="4" :sm="6" :xs="12">
        <el-form-item
          :label="L10n('supplier-contact')"
          prop="supplierContactID"
          :rules="getValidationRule('required')"
          class="material-style"
          :error="supplierError"
        >
          <select-company-contact
            :companyID="form.supplierCompanyID"
            :model.sync="form.supplierContactID"
            @on-change="(value, data, title) => autoSave('supplierContactID', { label: title, required: true, ...configRFQ2 })"
          ></select-company-contact>
        </el-form-item>
      </el-col>
      <el-col :lg="3" :sm="6" :xs="12">
        <el-form-item
          :label="L10n('part')"
          prop="partID"
          class="material-style"
        >
          <select-part-number
            :model.sync="form.partID"
            @on-change="(v, data, title) => autoSave('partID', { label: title })"
          ></select-part-number>
        </el-form-item>
      </el-col>
      <el-col :lg="3" :sm="6" :xs="12">
        <el-form-item
          :label="L10n('part-SN')"
          prop="partSN"
          class="material-style"
        >
          <el-input
            :value="form.partSN"
            @input="form.partSN = valueTrimLeft($event)"
            @change="autoSave('partSN')"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :lg="2" :sm="6">
        <el-form-item
          :label="L10n('price')"
          prop="price"
          class="material-style"
        >
          <el-input
            :value="form.price"
            @input="form.price = valueTrimLeft($event)"
            @change="autoSave('price', { ...configRFQ2 })"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :lg="2" :sm="6">
        <el-form-item
          :label="L10n('currency')"
          prop="currencyID"
          :rules="getValidationRule('required')"
          class="material-style"
        >
          <select-response
            :model.sync="form.currencyID"
            @on-change="(value, data, title) => autoSave('currencyID', { label: title, required: true, ...configRFQ2  })"
            :isLoading="dataSourceCurrency.loading"
            :data="dataSourceCurrency.records"
            :clearable="false"
          ></select-response>
        </el-form-item>
      </el-col>
      <el-col :lg="2" :sm="6">
        <el-form-item
          :label="L10n('condition')"
          prop="conditionID"
          :rules="getValidationRule('required')"
          class="material-style"
        >
          <select-response
            :model.sync="form.conditionID"
            @on-change="(value, data, title) => autoSave('conditionID', { label: title, required: true, ...configRFQ2  })"
            :isLoading="dataSourceCondition.loading"
            :data="dataSourceCondition.records"
            :clearable="false"
          ></select-response>
        </el-form-item>
      </el-col>
    </el-row>
    <view-more :isLazy="false">
      <el-row :gutter="10" class="section-supplier py-2">
        <el-col :xs="24">
          <sale-orders :salesOrders="data.salesOrders" />
        </el-col>
      </el-row>
      <el-row :gutter="10" class="section-customer py-2 mb-4">
        <el-col :lg="3" :sm="6" :xs="12">
          <el-form-item
            :label="L10n('po')"
            :rules="getValidationRule('required')"
            prop="po"
            class="material-style"
          >
            <el-input
              :value="form.po"
              @input="form.po = valueTrimLeft($event)"
              @change="autoSave('po', { required: true, ...configRFQ })"
            />
          </el-form-item>
        </el-col>
        <el-col :lg="5" :sm="6" :xs="12">
          <el-form-item
            :label="L10n('customer')"
            prop="rfqCustomerCompanyID"
            :rules="getValidationRule('required')"
            class="material-style"
          >
            <select-company
              :model.sync="form.customerCompanyID"
              @on-change="(value, data, title) => mixChangeCustomerID(value, { label: title, required: true, ...configRFQ })"
              @on-created="(data) => mixCreateCustomer(data, { label: data.name, ...configRFQ })"
            >
            </select-company>
          </el-form-item>
        </el-col>
        <el-col :lg="4" :sm="6" :xs="12">
          <el-form-item
            :label="L10n('customer-contact')"
            prop="customerContactID"
            class="material-style">
            <select-company-contact
              :companyID="form.customerCompanyID"
              :model.sync="form.customerContactID"
              @on-change="(value, data, title) => autoSave('customerContactID', { label: title, ...configRFQ })"
              @on-create="(data) =>autoSave('customerContactID', { label: data.name, ...configRFQ })"
            />
          </el-form-item>
        </el-col>
        <el-col :lg="3" :sm="6" :xs="12">
          <el-form-item
            :label="L10n('po-date')"
            prop="poDate"
            class="material-style"
          >
            <date-picker
              v-model="form.poDate"
              @change="autoSave('poDate', configRFQ)"
            ></date-picker>
          </el-form-item>
        </el-col>
        <el-col :lg="2" :sm="6" :xs="12">
          <el-form-item
            :label="L10n('requested-date')"
            prop="requestedDate"
            class="material-style"
          >
            <date-picker
              v-model="form.requestedDate"
              @change="autoSave('requestedDate', configRFQ)"
            />
          </el-form-item>
        </el-col>
        <el-col :lg="2" :sm="6" :xs="12">
          <el-form-item
            :label="L10n('rfq-type')"
            prop="rfqTypeID"
            class="material-style"
          >
            <select-response
              :model.sync="form.rfqTypeID"
              @on-change="(value, data, title) => autoSave('rfqTypeID', { label: title, ...configRFQ })"
              :isLoading="dataSourceRfqType.loading"
              :data="dataSourceRfqType.records"
            />
          </el-form-item>
        </el-col>
        <el-col :lg="3" :sm="6" :xs="12">
          <el-form-item
            :label="L10n('employee')"
            prop="baxEmployeeID"
            class="material-style"
          >
            <select-response
              :model.sync="form.baxEmployeeID"
              @on-change="(value, data, title) => autoSave('baxEmployeeID', { label: title, ...configRFQ })"
              :data="dataSourceEmployee.records"
              :isLoading="dataSourceEmployee.loading"
            />
          </el-form-item>
        </el-col>
        <el-col :lg="2" :sm="6" :xs="12">
          <el-form-item
            prop="poIsOpen"
            class="material-style"
          >
            <el-checkbox
              v-model="form.poIsOpen"
              @change="autoSave('poIsOpen', configRFQ)"
            >
              {{L10n('po-is-open')}}
            </el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :lg="11" :sm="6" :xs="12">
          <el-form-item
            :label="L10n('observation')"
            prop="observation"
            class="material-style">
            <el-input
              :value="form.observation"
              @input="form.observation = valueTrimLeft($event)"
              @change="autoSave('observation', ...configRFQ)"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </view-more>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'
import { mixUpdateCustomer, mixUpdateSupplier, mixUpdateShipTo } from '@/mixins/companies'

export default {
  name: 'TopForm',
  mixins: [Form, mixUpdateCustomer, mixUpdateSupplier, mixUpdateShipTo],
  components: {
    'select-part-number': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectPartNumber/Index.vue'),
    'select-company': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompany/Index.vue'),
    'select-company-contact': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompanyContact/Index'),
    'view-more': () => import(/* webpackChunkName: 'UI' */ '@/components/UI/ViewMore.vue'),
    'sale-orders': () => import(/* webpackChunkName: 'ActivityTopFormPoWo' */ './SaleOrders.vue')
  },
  props: {
    supplierError: { required: true }
  },
  watch: {
    data: {
      handler () {
        console.log('data', this.data)
      },
      immediate: true
    }
  },
  computed: {
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name as title&filter=isActive==true')
    },
    dataSourceRfqType () {
      return this.API('RFQTypes/GetAllDynamic?select=id,title')
    },
    dataSourcePriority () {
      return this.API('Priorities/GetAllDynamic?select=id,title&orderBy=title')
    },
    dataSourcePaymentTerm () {
      return this.API('PaymentTerms/GetAllDynamic?select=id,title&orderBy=title')
    },
    dataSourceScore () {
      return this.API('Scores/GetAllDynamic?select=id,scoreText')
    },
    dataSourceCondition () {
      return this.API('Conditions/GetAllDynamic?select=id,title&orderBy=title asc')
    },
    dataSourceCurrency () {
      return this.API('Currencies/GetAllDynamic?select=id,title')
    },
    configRFQ () {
      return {
        id: this.form.rfqID,
        api: `RFQs/Patch/${this.form.rfqID}`
      }
    },
    configRFQ2 () {
      return {
        id: this.form.rfq2ID,
        api: `RFQ2s/Patch/${this.form.rfq2ID}`
      }
    }
  }
}
</script>
<style lang="stylus">
.section-supplier {
  background-color: rgba(#06aaea, 0.1);
}
.section-customer {
  background-color: rgba(red, 0.1);
}

</style>
